import styles from './NumericInput.scss';
import Cleave from 'cleave.js/dist/cleave-react-node';
import React, { useState } from 'react';
import LockClosedSmall from '../../../assets/images/lock-closed-small-16x16.svg';
import classNames from 'classnames';
import Tooltip from '../../../components/Tooltip';
import { formatMoney, unformatMoney } from '../../../core/utils';

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '';

  let numeric = value;

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return '';
    numeric = unformatMoney(trimmed);
  } else {
    numeric = Number(value);
  }

  if (Number.isNaN(numeric)) return '';

  const formatted = formatMoney(numeric);

  // Hide trailing ",00" / ".00" so integers render as "5" (not "5,00"), incl. 0 and negatives.
  return formatted.replace(/([,.])00$/, '');
};

const NumericInput = ({
  defaultValue = '',
  onBlur,
  readOnly,
  tooltip,
  customWrapperStyles,
  dateFormat = false,
  ...rest
}) => {
  const formatValue = (rawValue) => {
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return '';
    }

    if (dateFormat) {
      return rawValue;
    }

    const cleaned = String(rawValue).replace(/[^\d,.-]/g, '');

    if (!cleaned) {
      return '';
    }

    const numeric = unformatMoney(cleaned);
    return Number.isNaN(numeric) ? '' : formatNumber(numeric);
  };

  const [value, setValue] = useState(formatValue(defaultValue));

  return (
    <Tooltip text={tooltip}>
      <div
        className={classNames(
          styles.wrapper,
          readOnly && styles.readOnly,
          customWrapperStyles
        )}
      >
        {readOnly && <LockClosedSmall />}
        <Cleave
          {...rest}
          readOnly={readOnly}
          className={styles.input}
          options={
            dateFormat
              ? {
                  delimiter: '.',
                  blocks: [2, 2, 4],
                  numericOnly: true,
                }
              : {
                  numericOnly: true,
                  numeral: true,
                  numeralDecimalScale: 2,
                  numeralDecimalMark: ',',
                  delimiter: '.',
                }
          }
          type='text'
          value={value}
          onChange={(e) => setValue(e.currentTarget.value)}
          onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()}
          onBlur={() => onBlur(dateFormat ? value : unformatMoney(value))}
        />
      </div>
    </Tooltip>
  );
};

export default NumericInput;
